import type { IconButtonCellProps } from "app/components/React/Table/cells/ExpansionButtonCell";
import { ExpansionButtonCell } from "app/components/React/Table/cells/ExpansionButtonCell";

import { useSerpOverlayContext } from "./SerpOverlay";

type Props = Omit<IconButtonCellProps, "onButtonClick">;

/** Requires SerpOverlayProvider — mounted in KeywordsCampaignsModuleFrame and Rank Tracker dashboard widgets via WidgetComponentV2. */
export const SerpExpansionButtonCell = (props: Props) => {
    const { openSerpOverlay } = useSerpOverlayContext();

    return (
        <ExpansionButtonCell
            {...props}
            onButtonClick={openSerpOverlay}
        />
    );
};
